import { IWebhookEventData } from "common/records/WebhookEvent";
import { ActionsUnion } from "common/reducers/UtilsTypes";
import { IWebhookData } from "common/records/Webhook";
import { createAction } from "common/reducers/Utils";

export const RECEIVE_WEBHOOK = "@webhooks/RECEIVE_WEBHOOK";
export const RECEIVE_WEBHOOK_EVENT = "@webhooks/RECEIVE_WEBHOOK_EVENT";
export const RECEIVE_WEBHOOKS = "@webhooks/RECEIVE_WEBHOOKS";
export const RECEIVE_WEBHOOK_EVENTS = "@webhooks/RECEIVE_WEBHOOK_EVENTS";
export const REMOVE_WEBHOOK = "@webhooks/REMOVE_WEBHOOK";
export const RESET_WEBHOOK = "@webhooks/RESET_WEBHOOK";
export const FETCH_WEBHOOK = "@webhooks/FETCH_WEBHOOK";
export const SET_UP_NEW_WEBHOOK = "@webhooks/SET_UP_NEW_WEBHOOK";
export const SET_WEBHOOK_LOADED = "@webhooks/SET_WEBHOOK_LOADED";

export const WebhookActions = {
  receiveWebhook: (webhook: Partial<IWebhookData>) => createAction(RECEIVE_WEBHOOK, webhook),
  receiveWebhookEvent: (webhook_event: Partial<IWebhookEventData>) =>
    createAction(RECEIVE_WEBHOOK_EVENT, webhook_event),
  receiveWebhooks: (webhooks: Partial<IWebhookData>[]) => createAction(RECEIVE_WEBHOOKS, { webhooks }),
  receiveWebhookEvents: (webhook_events: Partial<IWebhookEventData>[]) =>
    createAction(RECEIVE_WEBHOOK_EVENTS, { webhook_events }),
  removeWebhook: (webhookId: string) => createAction(REMOVE_WEBHOOK, { webhookId }),
  fetchWebhook: (id: string) => createAction(FETCH_WEBHOOK, id),
  setWebhookLoaded: (id: string) => createAction(SET_WEBHOOK_LOADED, id),
  resetWebhook: (webhookId: string) => createAction(RESET_WEBHOOK, { webhookId }),
};

export type WebhookActions = ActionsUnion<typeof WebhookActions>;
